function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:none;stroke:#D1D1D6;stroke-miterlimit:10;stroke-width:1.5px}\n        "));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Telegram_Attachement",
  d: "M18.652 13.824s-2.217 2.251-7.234 7.058-15.012-3.9-10.093-9.52A112.374 112.374 0 0 1 11.718 1.088c4.622-3.753 9.968 3.133 6.934 6.626l-9.409 9.747c-2.311 1.991-6.094-1.532-4.126-4.14l6.6-6.721",
  className: "cls-1",
  "data-name": "Telegram / Attachement",
  transform: "translate(.758 .92)"
});

var SvgAttachIcn = function SvgAttachIcn(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21.251,
    height: 23.953,
    viewBox: "0 0 21.251 23.953",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAttachIcn, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/attach_icn.08517a89.svg";
export { ForwardRef as ReactComponent };